import React, { useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useDispatch } from "react-redux";
import { Breathing, Image } from "react-shimmer";
import { reorderSlideShowPhotos } from "../../../store/actions/slideshowActions";

const Reorder = (props) => {
  const [updatedOrder, setUpdatedOrder] = useState([]);
  const [changesMade, setChangesMade] = useState(false);

  const dispatch = useDispatch();
  useEffect(() => {
    if (props.data.length > 0 && !changesMade) {
      setUpdatedOrder(props.data);
    }
  }, [props.data]);
  useEffect(() => {
    if (props.save) {
      handleSaveOrder();
    }
  }, [props.save]);

  const handleOnDragEnd = (result) => {
    setChangesMade(true);
    if (!result.destination) return;
    const items = Array.from(updatedOrder);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setUpdatedOrder(items);
  };
  const handleSaveOrder = () => {
    const copyArray = JSON.parse(JSON.stringify(updatedOrder));
    const submitArray = copyArray.map((image) => image.id);
    dispatch(reorderSlideShowPhotos(submitArray));
    setChangesMade(false);
    props.handleSaveOff();
    props.close();
  };
  const listDrag = updatedOrder.map((image, index) => {
    return (
      <Draggable key={image.id} draggableId={image.id} index={index}>
        {(provided) => (
          <li
            key={image.order}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            <div className="card">
              <div className="card-body">
                <div className="two">
                  <Image
                    src={image.fileURL}
                    fallback={<Breathing width={400} height={300} />}
                  />
                </div>
              </div>
            </div>
          </li>
        )}
      </Draggable>
    );
  });
  return (
    <>
      <div className="team-section single p-0 reorder-slides-show">
        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Droppable droppableId="characters">
            {(provided) => (
              <ul
                className="drag-ul"
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {props.data.length > 0 && listDrag}
                {provided.placeholder}
              </ul>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </>
  );
};

export default Reorder;
